import styled from "styled-components";
import { TextSizes } from "@smartsuite/react-ui/lib";
import type { PartialBadgeStylesType } from "@smartsuite/react-ui/lib";
import {
  Colors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

interface IIntegrationLabel {
  fontSize: string;
  color: string;
  paddingLeft: string;
  textAlign: "left" | "center" | "right";
}

const IntegrationLabelStyled = styled.span<Partial<IIntegrationLabel>>`
  width: 100%;
  padding-left: ${({ paddingLeft }) => paddingLeft};
  text-align: ${({ textAlign }) => textAlign};
  color: ${({ color }) => color};
`;

IntegrationLabelStyled.defaultProps = {
  paddingLeft: "10px",
  textAlign: "left",
  color: TextColorNames.tertiary,
  fontSize: ".9em",
};

export const StyledTriggerRequest = styled.div`
  padding: 0 20px 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: ${TextColorNames.secondary};

  button {
    color: ${SolutionColorVariables.sc1};
    cursor: pointer;
    text-decoration: none;
    transition: color 200ms ease;

    &:hover {
      color: ${SolutionColorVariables.sc3};
    }
  }
`;

export const BetaWrapper = styled.span`
  position: relative;
  top: -1px;

  display: inline-flex;
  margin-left: 10px;
`;

export const betaStyle: PartialBadgeStylesType = {
  background: Colors.dwYellow,
  textColor: TextColorNames.tertiary,
  textSize: TextSizes.XXXS,
  borderRadius: 10,
  sidePadding: 7,
  textWeight: "regular",
  height: 17,
};
